/**
 * @format
 */
/* eslint-disable max-len */

export const errorMessages = {
  login: 'Please check your login credentials.',
};
export const phoneRegex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
